export enum Themes {
    defaultTheme = 'default',
    ygRebrand = 'yg-rebrand',
}
